export default [
  {
    path: "/municipios",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "municipios_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Municipios", to: "municipios_list" }],
          permission: "municipio:view"
        }
      },
      {
        name: "municipios_show",
        path: ":id",
        component: () => import("./pages/Show"),
        meta: {
          breadcrumbs: [{ label: "Municipios", to: "municipios_ver" }],
          permission: "municipio:view"
        }
      }
    ]
  }
];
